import { useContext } from 'react'
import styles from './historic-sociogram.module.scss'
import { EventsContext } from '@BUP/contexts/EventsContext'
import CollapseElement from './collapse-element'
import { ResultsGroupedByYearContext } from '@BUP/contexts/ResultsGroupedByYearContext'

const HistoricSociogramContent = () => {
  const { events } = useContext(EventsContext)
  const currentSociogramsIds = events.map(event => event?.activityId).filter(Boolean)
  const { results } = useContext(ResultsGroupedByYearContext)

  const filteredResults = Object.entries(results).reduce((acc, [year, yearResults]) => {
    const validResults = yearResults.filter(result => !currentSociogramsIds.includes(result?.survey?.sociogram_id))
    if (validResults.length) acc[year] = validResults
    return acc
  }, {})

  if (Object.keys(filteredResults).length === 0) return null

  const sortedResultsKeys = Object.keys(filteredResults).sort((a, b) => {
    const latestA = Math.max(...filteredResults[a].map(result => new Date(result.created_at).getTime()))
    const latestB = Math.max(...filteredResults[b].map(result => new Date(result.created_at).getTime()))
    return latestB - latestA
  })
  return (
    <div className='collapse-wrapper'>
      <div className={styles.collapse_wrapper}>
        {sortedResultsKeys.map(year => {
          const sortedResults = filteredResults[year].sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
          return (
            <div className='historic-collapse-element' key={year}>
              <CollapseElement year={year} sortedResults={sortedResults} />
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default HistoricSociogramContent
